import { render, staticRenderFns } from "./AnimateTextType.vue?vue&type=template&id=48be7ae8&lang=pug&"
import script from "./AnimateTextType.vue?vue&type=script&lang=js&"
export * from "./AnimateTextType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports